import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

const Breadcrumb = ({ pageTitle, onBack, breadcrumbOverride }) => {
  const location = useLocation();
  void pageTitle;
  void onBack;

  const getBreadcrumbs = () => {
    if (breadcrumbOverride) {
      return breadcrumbOverride;
    }

    const paths = location.pathname.split('/').filter(Boolean);
    const breadcrumbs = [{ label: 'Home', path: '/' }];

    paths.forEach((path, index) => {
      const label = path
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
      const fullPath = '/' + paths.slice(0, index + 1).join('/');
      breadcrumbs.push({ label, path: fullPath });
    });

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <Box>
      <Box sx={{ padding: '12px 24px', display: 'flex', alignItems: 'center', gap: 1 }}>
        {breadcrumbs.map((crumb, index) => (
          <React.Fragment key={crumb.path}>
            {index === breadcrumbs.length - 1 ? (
              <Typography sx={{ color: 'white', fontSize: '14px', fontWeight: 400 }}>
                {crumb.label}
              </Typography>
            ) : (
              <>
                <Link to={crumb.path} style={{ color: 'white', textDecoration: 'none', fontSize: '14px', fontWeight: 400 }}>
                  {crumb.label}
                </Link>
                <Typography sx={{ color: 'white', fontSize: '14px' }}>›</Typography>
              </>
            )}
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
};

export default Breadcrumb;
